import { callable, mix, observable, watch } from "@chorda/core";
export const TextInput = (props) => {
    return mix({
        tag: 'input',
        css: 'input',
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        events: {
            $dom: {
                input: (e, scope) => {
                    scope.value.$value = e.target.value;
                    scope.onInput(e);
                },
                focus: (e, scope) => {
                    scope.onFocus();
                },
                blur: (e, scope) => {
                    scope.onBlur();
                },
                keydown: (e, scope) => {
                    if (e.code == 'Escape') {
                        scope.onEsc();
                    }
                }
            },
            onInput: props.onInput,
            onFocus: props.onFocus,
            onBlur: props.onBlur,
            onEsc: props.onEsc,
        },
        defaults: {
            value: () => observable(props.value || ''),
            onInput: () => callable(null),
            onFocus: () => callable(null),
            onBlur: () => callable(null),
            onEsc: () => callable(null),
        },
        injections: {
            value: props.value$
        },
        reactions: {
            value: (v) => ({ dom: { defaultValue: v || '' } })
        },
        joints: {
            domValue: ({ value, $dom }) => {
                watch(() => {
                    const el = $dom.$value;
                    if (el) {
                        if (el.value != value.$value) {
                            el.value = value;
                        }
                    }
                }, [$dom, value]);
                // const changeValue = () => {
                //     const el = $dom.$value
                //     if (el) {
                //         const htmlValue = (el as HTMLInputElement).value
                //         if (htmlValue != value.$value) {
                //             (el as HTMLInputElement).value = value
                //         }
                //     }
                // }
                // value.$subscribe(changeValue)
                // $dom.$subscribe(changeValue)
            },
            // autoFocus: props.autoFocus && (({$dom}) => {
            //     watch(() => {
            //         if ($dom.$value) {
            //             $dom.$value.focus()
            //         }
            //     }, [$dom])
            // })
        },
        dom: {
            placeholder: props.placeholder,
            type: props.type,
        }
    });
};
